var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { muiChevronDown, muiChevronUp } from '@ally/metronome-icons';
import { Button } from '../../Button';
import { get } from '../..';
import { DrawerProvider, getPublicRowStateProps, } from '../utils';
import { getBoxShadow } from '../shared';
var StyledDrawer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    padding: ", ";\n    border-top: 1px solid ", ";\n    background-color: ", ";\n  }\n"], ["\n  && {\n    padding: ", ";\n    border-top: 1px solid ", ";\n    background-color: ", ";\n  }\n"])), get.space('xs'), get.colors('grey-80'), get.colors('light-gray'));
var StyledToggle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    padding: ", ";\n    ", "\n    border-top: 1px solid ", ";\n    background-color: ", ";\n    text-align: center;\n  }\n"], ["\n  && {\n    padding: ", ";\n    ", "\n    border-top: 1px solid ", ";\n    background-color: ", ";\n    text-align: center;\n  }\n"])), get.space('xs'), getBoxShadow(true), get.colors('grey-80'), get.colors('white'));
var CardDrawer = function (_a) {
    var mdDownDrawerName = _a.mdDownDrawerName, drawer = _a.drawer, toggleDrawer = _a.toggleDrawer, openDrawerWithToggle = _a.openDrawerWithToggle, closeDrawerAndFocus = _a.closeDrawerAndFocus, isDrawerOpen = _a.isDrawerOpen, drawerToggleRef = _a.drawerToggleRef, drawerTargetRef = _a.drawerTargetRef, row = _a.row;
    return (React.createElement(React.Fragment, null,
        isDrawerOpen && (React.createElement(StyledDrawer, null,
            React.createElement(DrawerProvider, { value: __assign(__assign({ row: row }, getPublicRowStateProps(row)), { closeDrawer: closeDrawerAndFocus, targetRef: drawerTargetRef }) }, drawer))),
        React.createElement(StyledToggle, null,
            React.createElement(Button, { variant: "link", text: mdDownDrawerName, icon: {
                    map: isDrawerOpen ? muiChevronUp : muiChevronDown,
                    position: 'right',
                }, onClick: function () {
                    if (!isDrawerOpen) {
                        openDrawerWithToggle();
                    }
                    else {
                        toggleDrawer(false);
                    }
                }, "aria-expanded": isDrawerOpen ? 'true' : 'false', ref: drawerToggleRef, "data-track-elem": "button", "data-track-name": mdDownDrawerName, "data-track-state": isDrawerOpen ? 'opened' : 'closed' }))));
};
export default CardDrawer;
var templateObject_1, templateObject_2;
//# sourceMappingURL=CardDrawer.js.map